<template>
  <PainelLayout>
    <Breadcrumb :lista="[
      { 'name':'Painel', 'link' : '/' }]"
    />

    <div class="row print-no-show">
      <div class="col-6">
        <span class="mb-2 fw-bold">Detalhes do Fornecedor</span>
      </div>
      <div class="col-6 text-end">
        <router-link class="btn btn-sm btn-primary me-2" :to="{ path: '/supplier/new', query: { edit: true, id: dados.id } }">
          <i class="bi bi-pencil-fill me-2"></i>Editar  
        </router-link>
        <button @click="imprimir()" class="btn btn-sm btn-secondary"><i class="bi bi-printer me-2"></i>Imprimir</button>
      </div>
    </div>
    <hr class="print-no-show"/>

    <div v-if="!loaded" class="row">
      <div class="col mx-auto " style="margin-bottom: 40px;" id="conteudoParaImprimir">
        <div class="card">
          <div class="card-body">
            <table class="table table-striped">
              <tbody>
                <tr>
                  <td colspan="2">Cliente: {{ dados.name }}</td>
                  <td colspan="1">Cidade: {{ dados.city }}</td>
                </tr>
                <tr>
                  <td>Tipo: {{ dados.type }}</td>
                  <td colspan="2"><span>{{ dados.type == 'PF' ? 'CPF' : 'CNPJ' }}</span>: {{ dados.cpf_cnpj }}</td>
                </tr>
                <tr v-if="dados.type == 'PJ'">
                  <td colspan="3">Nome Legal: {{ dados.name_legal }}</td>
                </tr>
                <tr v-if="dados.type == 'PJ'">
                  <td colspan="2">Nome do Responsável: {{ dados.responsible_name }}</td>
                  <td>Telefone do Responsável: {{ dados.responsible_phone }}</td>
                </tr>
                <tr>
                  <td>Telefone: {{ dados.phone }}</td>
                  <td colspan="2">Email: {{ dados.email }}</td>
                </tr>
                <tr>
                  <td>Endereço: {{ dados.address }}</td>
                  <td>Número: {{ dados.number }}</td>
                  <td>Bairro: {{ dados.neighbor }}</td>
                </tr>
                <tr>
                  <td colspan="2">Estado: {{ dados.state }}</td>
                  <td>CEP: {{ dados.zipcode }}</td>
                </tr>
                <tr>
                  <td colspan="3">Anotações: {{ dados.note }}</td>
                </tr>

                <!-- Fico devendo: ligar itens que ele fornce, listar itens -->
              </tbody>
            </table>
          </div>
        </div>
        <div class="card mt-2">
          <div class="card-body">
            <h6>Produtos Vinculados:</h6>
            <button @click="openModal('modal_selectItem')" class="btn btn-sm btn-primary"><i class="bi bi-bag-plus-fill me-2"></i>Vincular produto</button>
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nome</th>
                  <th>Codigo</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in dados.itens" :key="item.id">
                  <td>{{ item.id }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.code }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- Div Loading -->
    <div v-else class="d-flex justify-content-center p-3">
      <div class="spinner-border" style="width: 7rem; height: 7rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <!-- Modal Selecionar produto -->
    <div class="modal fade" id="modal_selectItem" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Selecionar Produto</h5>
              <button @click="closeModal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col">Nome</th>
                  <th scope="col">Codigo</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in listaProdutosBD" :key="item.id" @click="selectProduto(item)">
                  <td class="itemprodutoslist">{{ item.id }}</td>
                  <td class="itemprodutoslist">{{ item.name }}</td>
                  <td class="itemprodutoslist">{{ item.code }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>  
      </div>
    </div>
    <!-- Modal de Confirmação -->
    <div class="modal fade" id="modal_confirmacao" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">{{ itemSelecionado.name }}</h5>
              <button @click="closeModal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>Deseja ligar o produto: {{ itemSelecionado.name }}, ao fornecedor: {{ dados.name }}</p>
          </div>
          <div class="modal-footer">
            <button @click="closeModal" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
            <button @click="confirm" type="button" class="btn btn-primary">Confirmar</button>
          </div>
        </div>  
      </div>
    </div>
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { onMounted, reactive, ref } from 'vue';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import { supplier } from '@/models/supplier';
import { itens } from '@/models/itens';
import { Modal } from "bootstrap";

export default {
  name: "DetailsView",
  components: { PainelLayout, Breadcrumb },
  setup(props) {

    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');
    let modal = '';
    const model = supplier();
    const modelprodutos = itens();
    const listaProdutosBD = ref([]);
    var loaded = ref(true);

    var itemSelecionado = reactive({
      id: null,
      name: null,
      code: null
    });

    async function refreshProdutosBD(){
      const allProducts = await modelprodutos.list();
      listaProdutosBD.value = allProducts.filter(product => 
        !dados.itens.some(item => item.id === product.id)
      );
    }

    function openModal(elemento) {
      const modalObj = document.getElementById(elemento);
      modal = new Modal(modalObj);
      modal.show();
    };

    function selectProduto(item) {
      closeModal();
      itemSelecionado.id = item.id;
      itemSelecionado.name = item.name;
      itemSelecionado.code = item.code;
      openModal('modal_confirmacao');
    }

    function closeModal() {
      modal.hide();
    };

    var dados = reactive({
      id: null,
      name: null,
      name_legal: null,
      email: null,
      cpf_cnpj: null,
      phone: null,
      responsible_phone: null,
      responsible_name: null,
      address: null,
      number: null,
      neighbor: null,
      city: null,
      state: null,
      zipcode: null,
      note: null,
      type: null,
      itens: []
    });

    function imprimir() {
      window.print();
    }

    async function confirm() {
      closeModal();
      loaded.value = true;
      await model.linkItem(dados.id, itemSelecionado.id).then((response) => {
        if(response.status == 200){
          getDados();
          closeModal();
        }
        loaded.value = false;
        getDados()
      });
    }
    
    async function getDados() {
      loaded.value = true;
      const response = await model.getOne(id);
      dados.id = response.id;
      dados.name = response.name;
      dados.name_legal = response.name_legal;
      dados.email = response.email;
      dados.cpf_cnpj = response.cpf_cnpj;
      dados.phone = response.phone;
      dados.responsible_phone = response.responsible_phone;
      dados.responsible_name = response.responsible_name;
      dados.address = response.address;
      dados.number = response.number;
      dados.neighbor = response.neighbor;
      dados.city = response.city;
      dados.state = response.state;
      dados.zipcode = response.zipcode;
      dados.note = response.note;
      dados.type = response.type;
      dados.itens = response.itens;
      loaded.value = false;
      refreshProdutosBD();
    }

    onMounted(() => {
      getDados();
    });

    return {
      dados,
      imprimir,
      closeModal,
      openModal,
      listaProdutosBD,
      selectProduto,
      itemSelecionado,
      confirm,
      loaded
    }
  }
}
</script>

<style scoped>

  .header-print {
    display: none;
  }

  tr:hover>.itemprodutoslist {
    background: #cacaca67 !important;
  }

  @media print {
    /* Esconde tudo no corpo */
    body * {
      visibility: hidden;
    }

    .print-no-show {
      display: none !important;
    }

    .header-print {
      display: block;
      margin-bottom: 20px;
      margin-top: -10px;
    }
    
    /* Mostra apenas a div de impressão */
    #conteudoParaImprimir, #conteudoParaImprimir * {
      visibility: visible;
    }
    
    /* Opcional: Forçar quebra de página */
    #conteudoParaImprimir p {
      page-break-inside: avoid;
    }
  }

</style>